/**
 * System Info utility - Web implementation using browser APIs
 * Structure ready for Capacitor Device API (to be added later)
 */

/**
 * Get system information
 * @returns {Object} System information object
 */
export function getSystemInfoSync() {
  const info = {
    platform: 'web',
    system: navigator.platform || '',
    brand: navigator.vendor || '',
    model: navigator.userAgent || '',
    pixelRatio: window.devicePixelRatio || 1,
    screenWidth: window.screen.width || 0,
    screenHeight: window.screen.height || 0,
    windowWidth: window.innerWidth || 0,
    windowHeight: window.innerHeight || 0,
    statusBarHeight: 0,
    safeArea: {
      top: 0,
      bottom: window.innerHeight,
      left: 0,
      right: window.innerWidth,
      width: window.innerWidth,
      height: window.innerHeight,
    },
    language: navigator.language || 'en',
    version: navigator.appVersion || '',
    fontSizeSetting: 16,
    SDKVersion: '',
    batteryLevel: 100,
    wifiEnabled: navigator.onLine,
    locationEnabled: false,
    locationAuthorized: false,
    bluetoothEnabled: false,
    bluetoothAvailable: false,
    albumAuthorized: false,
    cameraAuthorized: false,
    microphoneAuthorized: false,
    notificationAuthorized: false,
    notificationAlertAuthorized: false,
    notificationBadgeAuthorized: false,
    notificationSoundAuthorized: false,
    bluetoothAvailable: false,
    enableDebug: false,
  }

  // Detect mobile devices
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())
  
  if (isMobile) {
    info.platform = 'android' // Default to android for mobile web
    if (/iphone|ipad|ipod/i.test(userAgent)) {
      info.platform = 'ios'
    }
  }

  return info
}

/**
 * Get system information asynchronously
 * @returns {Promise<Object>} System information object
 */
export function getSystemInfo() {
  return Promise.resolve(getSystemInfoSync())
}

// Export as default object for compatibility
export default {
  getSystemInfoSync,
  getSystemInfo,
}

